const EXEMPLES_PAR_DEFAUT = ['Exemple 1', 'Exemple 2'];

const nomEgal = (...noms) => ({ nom }) => noms.includes(nom);
const nomContient = (...mots) => ({ nom }) => mots.some((mot) => nom.includes(mot));
const libelleContient = (...mots) => ({ libelle }) => mots.some((mot) => libelle.includes(mot));
const typeEgal = (...types) => ({ type }) => types.includes(type);
const unDesTests = (...tests) => (contexte) => tests.some((test) => test(contexte));

const NOMS_PAR_MODELE = [
  { modeles: ['employee', 'hr.employee'], exemples: ['Jean Dupont', 'Marie Martin'] },
  { modeles: ['contract', 'hr.contract'], exemples: ['CDI - Jean Dupont', 'CDD - Marie Martin'] },
  { modeles: ['prime', 'excohsp.regle'], exemples: ['Prime de Rendement', 'Indemnité de Logement'] },
];

const exemplesNom = ({ modele }) => {
  const entree = NOMS_PAR_MODELE.find(({ modeles }) => modeles.includes(modele));
  return entree ? entree.exemples : EXEMPLES_PAR_DEFAUT;
};

const exemplesSelection = ({ selection }) => {
  const valeurOption = (option) => (Array.isArray(option) ? (option[1] || option[0]) : option);
  return [valeurOption(selection[0]), valeurOption(selection[1 % selection.length])];
};

const exemplesDate = ({ nom }) => {
  if (nom.includes('birth')) return ['15/05/1990', '20/11/1985'];
  if (nom.includes('end')) return ['', '31/12/2024'];
  return ['01/01/2024', '01/06/2024'];
};

const exemplesRelation = ({ nom }) => {
  if (nom === 'contract_type_id') return ['CDI', 'CDD'];
  if (nom.includes('employee')) return ['EMP001', 'Marie Martin'];
  return EXEMPLES_PAR_DEFAUT;
};

// Les règles sont parcourues dans l'ordre : la première qui correspond l'emporte.
const REGLES_CHAMPS = [
  { test: unDesTests(nomEgal('gender'), libelleContient('genre', 'sexe')), valeurs: ['Homme', 'Femme'] },
  { test: unDesTests(nomEgal('marital'), libelleContient('matrimonial')), valeurs: ['Célibataire', 'Marié'] },
  { test: unDesTests(nomEgal('state'), libelleContient('statut', 'état')), valeurs: ['En cours', 'Brouillon'] },
  { test: typeEgal('boolean'), valeurs: ['Non', 'Oui'] },
  {
    test: ({ type, selection }) => type === 'selection' && Array.isArray(selection) && selection.length > 0,
    valeurs: exemplesSelection,
  },
  { test: nomEgal('identification_id', 'matricul', 'identifiant'), valeurs: ['EMP001', 'EMP002'] },
  { test: nomEgal('name'), valeurs: exemplesNom },
  { test: nomContient('email'), valeurs: ['jean.dupont@example.com', 'marie.martin@example.com'] },
  { test: nomContient('phone'), valeurs: ['+33 6 12 34 56 78', '+33 6 98 76 54 32'] },
  { test: unDesTests(nomContient('job'), libelleContient('poste')), valeurs: ['Développeur Senior', 'Chef de Projet'] },
  { test: unDesTests(nomContient('department'), libelleContient('département')), valeurs: ['Informatique', 'Ressources Humaines'] },
  { test: unDesTests(nomContient('manager'), libelleContient('responsable')), valeurs: ['Marc Martin', 'Sophie Bernard'] },
  { test: nomContient('nationality', 'country'), valeurs: ['France', 'Sénégal'] },
  { test: nomContient('location', 'place'), valeurs: ['Paris', 'Lyon'] },
  { test: nomContient('ssnid', 'secu'), valeurs: ['1900575123456', '2920875654321'] },
  { test: nomContient('passport'), valeurs: ['12AA34567', '98ZZ65432'] },
  { test: nomContient('bank', 'banque'), valeurs: ['BNP Paribas', 'Société Générale'] },
  { test: nomContient('account', 'iban'), valeurs: ['FR7630004012345678901234567', 'FR7630004098765432109876543'] },
  { test: nomContient('street', 'address'), valeurs: ['12 Rue de la Paix, 75002 Paris', '45 Avenue Victor Hugo, 69002 Lyon'] },
  { test: unDesTests(typeEgal('date'), nomContient('date', 'birthday')), valeurs: exemplesDate },
  { test: typeEgal('datetime'), valeurs: ['01/01/2024 09:00:00', '01/06/2024 09:00:00'] },
  {
    test: unDesTests(typeEgal('float', 'monetary'), nomContient('wage', 'salary', 'valeur', 'amount', 'premium')),
    valeurs: [3500, 2800],
  },
  {
    test: unDesTests(typeEgal('integer'), nomContient('children', 'duration', 'hours', 'worked')),
    valeurs: [2, 1],
  },
  { test: typeEgal('many2one'), valeurs: exemplesRelation },
];

const REGLES_CONFIG = [
  { test: nomContient('matricul', 'identifi'), valeurs: ['EMP001', 'EMP002'] },
  { test: unDesTests(nomContient('name', 'nom'), libelleContient('employé')), valeurs: ['Jean Dupont', 'Marie Martin'] },
  { test: nomContient('days', 'jour'), valeurs: [22, 20] },
  { test: nomContient('amount', 'montant', 'salary', 'gross', 'brut'), valeurs: [3500, 2800] },
  { test: nomContient('date'), valeurs: ['01/2024', '02/2024'] },
];

const choisirExemples = (regles, contexte) => {
  const regle = regles.find(({ test }) => test(contexte));
  if (!regle) return EXEMPLES_PAR_DEFAUT;
  return typeof regle.valeurs === 'function' ? regle.valeurs(contexte) : regle.valeurs;
};

const enMinuscules = (valeur) => valeur.toString().toLowerCase();

export function genererLignesExemple(champs, modele) {
  const ligne1 = {};
  const ligne2 = {};

  champs.forEach((champ) => {
    const contexte = {
      nom: enMinuscules(champ.name || champ || ''),
      libelle: enMinuscules(champ.string || ''),
      type: champ.type || 'char',
      selection: champ.selection,
      modele,
    };
    const entete = typeof champ === 'object' ? (champ.string || champ.name) : champ;
    [ligne1[entete], ligne2[entete]] = choisirExemples(REGLES_CHAMPS, contexte);
  });

  return [ligne1, ligne2];
}

export function genererLignesExempleDepuisConfig(champs, entetes) {
  const champsUtilises = champs && champs.length > 0
    ? champs
    : entetes.map((entete) => ({ name: entete, string: entete }));
  const ligne1 = {};
  const ligne2 = {};

  entetes.forEach((entete) => {
    const champ = champsUtilises.find((c) => (c.string || c.name) === entete) || { name: entete, string: entete };
    const contexte = {
      nom: enMinuscules(champ.name || champ.string || champ || ''),
      libelle: enMinuscules(champ.string || champ.name || ''),
    };
    [ligne1[entete], ligne2[entete]] = choisirExemples(REGLES_CONFIG, contexte);
  });

  return [ligne1, ligne2];
}
